import { render, staticRenderFns } from "./ChartjsHorizontalBarChart.vue?vue&type=template&id=35928bcb&"
import script from "./ChartjsHorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports